const {
  NODE_ENV,
  REACT_APP_SHOP_MANAGER_API,
  REACT_APP_IMAGE_BASE_URL,
  REACT_APP_MEDIA_BASE_URL,
  REACT_APP_SENTRY_DSN,
  REACT_APP_ASSET_MANAGER_BASE_URL,
  REACT_APP_GOOGLE_FONTS_API_KEY
} = process.env;

const environment = NODE_ENV;
const shopManagerApi = REACT_APP_SHOP_MANAGER_API;
const isProd = REACT_APP_SHOP_MANAGER_API === 'https://shopmanager.dermpro.com/v1';
const imgBaseUrl = REACT_APP_IMAGE_BASE_URL;
const mediaBaseUrl = REACT_APP_MEDIA_BASE_URL;
const sentryDns = REACT_APP_SENTRY_DSN;
const assetManagerUrl = REACT_APP_ASSET_MANAGER_BASE_URL;
const googleFontsApiKey = REACT_APP_GOOGLE_FONTS_API_KEY;
const happyfoxUrl = 'https://dermpro.happyfox.com/home/';

export {
  environment,
  shopManagerApi,
  isProd,
  imgBaseUrl,
  mediaBaseUrl,
  sentryDns,
  assetManagerUrl,
  googleFontsApiKey,
  happyfoxUrl
};
